module.exports = __webpack_public_path__ + "img/v0.fc6723db.svg";